import React from 'react'
import HeroSection from '../components/HeroSection'
import { Typography, Box, Container, Button, Slider } from '@mui/material'
import { ContentCard } from '../assets/data'
import ArrowForwardIosOutlinedIcon from '@mui/icons-material/ArrowForwardIosOutlined';
import FaqSection from '../components/FaqSection'
import { ContectFAQ } from '../assets/data'
import Footer from "../components/Footer"
import bagimg from "../assets/bag.png"
import porsenimg from "../assets/profile.png"
import ArrowBtn from '../components/ArrowBtn';
import { Link,useNavigate } from 'react-router-dom';
import useMediaQuery from '@mui/material/useMediaQuery';
import conteectimg from "../assets/contectD.png"
const Contect = () => {
    const matches = useMediaQuery('(max-width:500px)');
    const navigate = useNavigate();

  const handleClick = () => {
  navigate('/', {state:{ fromAboutUs: true} });
  };
    return (
        <>
            <div style={{ background: "rgba(96, 76, 212, 0.05)" }}>
                <Box className="Hero_main"
                    style={{ backgroundImage: `url(${conteectimg})`, height: matches ? '100vh' : '120vh' }} >
                    <Box className="hero_div">
                        <h1 className='herotitle'>
                        Contact Us
                        </h1>
                        {/* <Link to='/BookRepair'> */}
                            <Button variant="contained" className='herobtn1' onClick={handleClick} >
                            WeCare Plans
                            </Button>
                        {/* </Link> */}
                    </Box>
                </Box>
            </div>

            <Container maxWidth="xl">
                <Box className="contect_cards_div" mt={"5rem"}>
                    <Box className="CardsTo">
                        <Box className='card_title_div'>
                            <Typography variant="h5" fontWeight={500}>Opening Hours</Typography>
                        </Box>
                        <Box className="card_text">
                            <Typography variant="body1" p={"5px 0px"}><strong>General Repairs:</strong></Typography>
                            <Typography variant="body1" m={'7px 0px'}><strong>Hours:</strong> 8.30am - 5.30pm, Monday - Friday (except public holidays).</Typography>
                            <Typography variant="body1" p={"7px 0px"}><strong>Customer Service</strong></Typography>
                            <Typography variant="body1" m={'7px 0px'}>Hours: 8.30am - 5.30pm, Monday - Friday (except public holidays).</Typography>
                            <Typography variant="body1" p={"8px 0px"}><strong>Emergency repairs 24/7</strong></Typography>
                            <Typography variant="body1" p={"8px 0px"}><strong>Call</strong> 07930906064</Typography>
                            <Typography variant="body1">
                                If you are an existing customer and:
                                <ul className='ul_about'>
                                    <li>Have an uncontrollable water leak;</li>
                                    <li>Are completely locked out of your <br /> property; or</li>
                                    <li>Have been broken into and your<br /> property is not secure.</li>
                                </ul>
                            </Typography>
                            <Typography variant="body1"><strong>Hours:</strong> Always open</Typography>
                        </Box>
                    </Box>
                    <Box className="CardsTo">
                        <Box className='card_title_div'>
                            <Typography variant="h5" fontWeight={500}>Contact Details</Typography>
                        </Box>
                        <Box className="text_Box">
                            <Box className="text_inner_div">
                                <Typography variant="h5" fontWeight={600} mb={1}>Smell gas?</Typography>
                                <Typography variant="body1">If you think you have a gas leak, call the free National Gas Emergencies number immediately on 0800 111 999.</Typography>
                            </Box>
                            <Typography variant="body1" p={"0px 1rem"} mt={3}> <strong>Contact Details</strong></Typography>

                            <Typography variant="body1" p={"0px 1rem"}><strong>Call</strong> 03301114442</Typography>
                            <Typography variant="body1" p={"0px 1rem"}><strong>Email </strong> info@wecareboilerrepair.com</Typography>
                            <Typography variant="body1" p={"0px 1rem"} mt={1}> <strong>Address</strong></Typography>
                            <Typography variant="body1" p={"0px 1rem"} mt={1}>WeCare Boiler Repair Ltd, <br /> 30 The Loont, <br /> Winsford, <br /> Cheshire, <br /> CW7 1EU</Typography>
                            
                        </Box>
                    </Box>
                </Box>
            </Container>
            <div className='contact_div last_content'>
                <Container maxWidth="xl">
                    <Box className="main_map_div">
                        <Typography variant="h3">Our Location</Typography>
                        <Box className="map_div">
                            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2391.0043864340446!2d-2.5377538871800596!3d53.18190117212635!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x487af75b6b2ca797%3A0x869a9ddfb353a62!2s30%20The%20Loont%2C%20Winsford%20CW7%201EU%2C%20UK!5e0!3m2!1sen!2s!4v1726737090626!5m2!1sen!2s" width="600" height="450" style={{border: '0px'}} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe></Box>
                    </Box>
                </Container>
            </div>
            <Footer />
        </>
    )
}

export default Contect
